import axios from 'axios';
import { URL } from '../config';

const BASE_URL = `${URL}/departments`;

const departmentService = {
  getDepartments: async ({ semester } = {}) => {
    try {
      const params = semester ? { semester } : {};
      const response = await axios.get(`${BASE_URL}/list`, { params });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || `Error fetching departments: ${error.message}`;
      throw new Error(message);
    }
  },

  getDepartment: async (id, { semester } = {}) => {
    try {
      const params = semester ? { semester } : {};
      const response = await axios.get(`${BASE_URL}/${id}`, { params });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.error || `Error fetching department: ${error.message}`;
      throw new Error(message);
    }
  },

  updateDepartment: async (id, data) => {
    try {
      const response = await axios.patch(`${BASE_URL}/${id}`, data);
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        `Error updating department: ${error.message}`;
      throw new Error(message);
    }
  },

  uploadCoverImage: async (id, file) => {
    try {
      const formData = new FormData();
      formData.append('coverImage', file);
      const response = await axios.put(`${BASE_URL}/${id}/cover-image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        `Error uploading cover image: ${error.message}`;
      throw new Error(message);
    }
  },

  deleteCoverImage: async (id) => {
    try {
      const response = await axios.delete(`${BASE_URL}/${id}/cover-image`);
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        `Error deleting cover image: ${error.message}`;
      throw new Error(message);
    }
  },

  updateMembers: async (id, semesterId, userIds) => {
    try {
      const response = await axios.put(`${BASE_URL}/${id}/members`, {
        semesterId,
        userIds,
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.error ||
        error.response?.data?.message ||
        `Error updating department members: ${error.message}`;
      throw new Error(message);
    }
  },
};

export default departmentService;
